
function MobileVerification() {
    /// <summary>
    /// This object provides js functions for the Widget.Phone.MobileVerification.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 3.2.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 3.2.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

    this.pin = -1;
}

MobileVerification.prototype = new vcTemplate();

MobileVerification.prototype.init = function () {
    var me = this;
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>

    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);

        //sends the request for the pin-sms
        me.visual.find("#btnSend").button().off("click").on("click", function () { me.send() });
        me.visual.find("#btnSkip").button().off("click").on("click", function () { me.skip() });

        //validates the input
        me.visual.find("#txtPin").off("keyup").on("keyup", function () { me.validate(); });
        me.visual.find("#txtPin").off("change").on("change", function () {me.validate();});


    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}


MobileVerification.prototype.skip = function () {
    /// <summary>
    ///  This function sends a request for updating the user state.
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }

           me.visual.find("#btnSend").button("enable");
           me.visual.find("#divVerify").hide();
           me.visual.find("#divDone").html(me.resources.verifyLater).show();

        return true;
    } catch (ex) { me.writeError('skip', ex); return false }

}

MobileVerification.prototype.validate = function () {
    /// <summary>
    ///  Validates of the entered pin is correct<br/>
    ///  If so - it updates the users mobile verification state
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (me.pin === -1) {return true}

        if (parseInt(me.visual.find("#txtPin").val(), 10) === me.pin) {
            me.visual.find("#txtPin").prop("disabled", "disabled").prop("readonly", "readonly");
            me.visual.find(".fa-check").show();
            //update the user state
            me.update();
        }
        return true;
    } catch (ex) { me.writeError('validate', ex); return false }

}


MobileVerification.prototype.send = function () {
    /// <summary>
    ///  This function generates a random pin and sends it to the mobile number. 
    /// </summary>
    var me = this;
    var mobile;
    
    try {
        if (me.error) {
            return false;
        }
        me.visual.find("#btnSend").button("disable");
        me.visual.find("#txtPin").val("").prop("disabled", "").prop("readonly", "");
        me.visual.find(".fa-check,#divDone").hide();
     
        mobile = me.visual.find("#divNr").attr("data-nr");
        me.pin = Math.floor((Math.random() * 10000) + 1);

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ 'mobile': mobile, 'pin': me.pin }),
       function (result) {
           if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
           if (result === false) {
               me.showMessage(me.resources.err_saveData, true); return false;
           }
          
           return true;
       });

        return true;
    } catch (ex) { me.writeError('send', ex); return false }

}

MobileVerification.prototype.update = function () {
    /// <summary>
    ///  This function sends a request for updating the user state.
    /// </summary>
    var me = this;

    try {
        if (me.error) {
            return false;
        }
      
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, '',
       function (result) {
           if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
           if (result === false) {
               me.showMessage(me.resources.err_saveData, true); return false;
           }
           me.visual.find("#btnSend").button("enable");
           me.visual.find("#divVerify").hide();
           me.visual.find("#divDone").show();
           return true;
       });

        return true;
    } catch (ex) { me.writeError('update', ex); return false }

}


MobileVerification.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#divDone, #divVerify").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


